module.exports = __webpack_public_path__ + "static/media/client-logo-24.464718ea.jpg";